import * as React from "react";
import { goTo } from "./utils";

const LS_BANNER_FLAG = "hasura-public-graphiql-banner";

export default function Banner({ authBase = "" }: { authBase?: string }) {
  const [bannerVisible, setBannerVisible] = React.useState(false);

  function dismissBanner() {
    localStorage.setItem(LS_BANNER_FLAG, "dismissed");
    setBannerVisible(false);
  }

  React.useEffect(
    function checkCloudSession() {
      if (localStorage.getItem(LS_BANNER_FLAG)) {
        setBannerVisible(false);
        return;
      }
      if (authBase.length) {
        fetch(authBase + "/webhook/api", {
          credentials: "include",
          method: "GET",
          headers: {
            "content-type": "application/json",
          },
        })
          .then((res) => res.json())
          .then((userInfo) => {
            if (
              "X-Hasura-Role" in userInfo &&
              userInfo["X-Hasura-Role"] !== "anonymous"
            )
              setBannerVisible(false);
            else setBannerVisible(true);
          })
          .catch(() => setBannerVisible(true));
      }
    },
    [authBase]
  );

  return bannerVisible ? (
    <div className="banner-top">
      <img
        className="mr-sm"
        src={process.env.PUBLIC_URL + "/hasura-logo.svg"}
        alt=""
      />
      <p className="intro-text">
        🗺️ This is an API preview. Create your own API with Hasura Cloud.
      </p>
      <button
        onClick={() => goTo(window.location.origin, true)}
        className="ml-auto hasura-cloud-btn"
      >
        Go to Hasura Cloud
      </button>
      <svg
        onClick={dismissBanner}
        xmlns="http://www.w3.org/2000/svg"
        className="icn ml-sm"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clipRule="evenodd"
        ></path>
      </svg>
    </div>
  ) : null;
}
